module.exports = __webpack_public_path__ + "static/img/21.4978c238.png";